import { render, staticRenderFns } from "./LsButton.vue?vue&type=template&id=6baa3e7c&scoped=true&"
import script from "./LsButton.vue?vue&type=script&lang=js&"
export * from "./LsButton.vue?vue&type=script&lang=js&"
import style0 from "./LsButton.vue?vue&type=style&index=0&id=6baa3e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa3e7c",
  null
  
)

export default component.exports